export default __webpack_public_path__ + "static/media/Sprint-Yono.03c9c52d.png";